import { fromJS, Map } from 'immutable';
import Label from '../../utils/models/Label';
import { WS_DATA_LABEL, WS_DATA_LABELS } from '../constants/label.constants';
import { AUTH_SUCCESS } from '../../containers/LoginPage/constants';

export const initialState = fromJS({
	data: {},
	fetched: false
});

export default function labelReducer(state: Map = initialState, action) {
	switch (action.type) {
		case AUTH_SUCCESS:
			return initialState;
		case WS_DATA_LABEL:
			return state
				.setIn(['data', action.data.id], new Label(action.data))
				.set('fetched', true);
		case WS_DATA_LABELS:
			return state
				.set('data', Map(action.data.map(l => new Label(l)).map(l => [l.id, l])))
				.set('fetched', true);
		default:
			return state;
	}
}
